import {
    ANY_ORIGIN,
    APPLIANCE_URL,
    AUTH_SESSION_TOKEN,
    EXTENDED_ATTRIBUTES,
    MAPPED_CAPABILITIES
} from "../constants/postMessages";

export const getSessionToken = () => {
    return sessionStorage.getItem(AUTH_SESSION_TOKEN);
}
export const setSessionToken = (sessionToken) => {
    sessionStorage.setItem(AUTH_SESSION_TOKEN, sessionToken);
}

export const getApplianceUrl = () => {
    return sessionStorage.getItem(APPLIANCE_URL);
}
export const setApplianceUrl = (applianceUrl) => {
    sessionStorage.setItem(APPLIANCE_URL, applianceUrl);
}
export const getOrigin = () => {
    let applianceUrl = sessionStorage.getItem(APPLIANCE_URL);
    if (applianceUrl) {
        return applianceUrl;
    } else {
        return ANY_ORIGIN;
    }
}
export const checkOrigin = (origin) => {
    let applianceUrl = sessionStorage.getItem(APPLIANCE_URL);
    return origin === applianceUrl;
}

export const getMappedCapabilities = () => {
    return sessionStorage.getItem(MAPPED_CAPABILITIES)
}
export const setMappedCapabilities = (mappedCapabilities) => {
    sessionStorage.setItem(MAPPED_CAPABILITIES, mappedCapabilities)
}

export const setExtendedAttributes = (extendedAttributes) => {
    sessionStorage.setItem(EXTENDED_ATTRIBUTES, extendedAttributes)
}

export const getExtendedAttributes = () => {
    return sessionStorage.getItem(EXTENDED_ATTRIBUTES)
}

export const removeItemFromStorage = (key) => {
    sessionStorage.removeItem(key)
}
export const clearStorage = () => {
    sessionStorage.clear()
}



// WEBPACK FOOTER //
// ./src/actions/storage.js